import angular from 'angular';

import _css from './od-tooltip.less';

// Reasons this is complex and requires JS:
// * Hover state is easy, but to support mobile, we should show/hide on click
// * If we show the tooltip on click, then we should make sure it's easy to
//   dismiss by clicking anywhere else on the screen.
// * If we want to get fancy (we might want to later), we could position the
//  tooltip to the top/right/bottom/left depending on how much space is left on
//  the screen.
module.exports = angular.module('common.directives.od-tooltip', [])
.directive('odTooltip', ($window, $mediaQuery) => {
  return {
    restrict: 'EA',
    scope: true,
    transclude: true,
    templateUrl: '/templates/common/directives/od-tooltip.html',
    link: (scope, elem) => {
      var hoverEl = elem.find('od-tooltip-hover');
      if (hoverEl.length < 1) {
        throw 'od-tooltip must have child od-tooltip-hover element';
      }

      var windowEl = angular.element($window);
      scope.isTooltipShown = false;

      if (elem.hasClass('help-text')) {
        scope.showQuestionMark = true;
      }

      scope.setHoverPosition = () => {
        var rect = elem[0].getBoundingClientRect();
        if ($mediaQuery('gt-xs')) {
          hoverEl.css({
            left: `${rect.left + rect.width/2}px`,
            top: `${rect.top - 6}px`
          });
        } else {
          hoverEl.css({
            left: '10px',
            right: '10px',
            width: 'initial',
            top: `${rect.top - 6}px`
          });
        }
      };

      scope.showTooltip = () => {
        scope.isTooltipShown = true;
        windowEl.on('scroll', scope.setHoverPosition);
      };

      scope.hideTooltip = () => {
        scope.isTooltipShown = false;
        windowEl.off('scroll', scope.setHoverPosition);
      };

      scope.$on('$destroy', scope.hideTooltip);
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/od-tooltip.js
 **/